export default {
  'marketing-preferences-title': 'Communication Preferences',
  'marketing-preferences-description': 'Spinstation offers its Player Community unique Daily Deals & Monthly Highlights such as match bonuses, bonus spins, free spins, cashback offers, tournaments, leaderboards, real life prizes, experiences and holidays. To hear about these, please select below:',
  'marketing-preferences-post-text': 'You can update your communication preferences at any time in your My Account section.',
  'marketing-preferences-label-cross-brand': 'I want to hear about exclusive offers from your casino network.',
  'marketing-preferences-label-brand-only': 'I want to hear about exclusive offers from your casino only.',
  'marketing-preferences-label-email': 'I want to hear about offers via <strong>email</strong>',
  'marketing-preferences-label-sms': 'I want to hear about offers via <strong>sms</strong>',
  'marketing-preferences-label-phone-call': 'I want to hear about offers via <strong>phone call</strong>',
  'marketing-preferences-label-post': 'I want to hear about offers via <strong>post</strong>',

  'trustly-signup': 'Sign up with trustly',
  'or-signup-option': 'or',
  'play-page-footer-button': 'View Footer',
}
